import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import { Row, Col } from 'react-flexbox-grid'
import {
  ContainerDivs,
  FinanceCompanyScore,
  FinanceFundScore,
  Link,
  LinkIcon,
  Grade,
  FundMenu,
  FundName,
  FundShareTakeAction,
  InlineSignup,
  IyvScorecard,
  FinanceCompanyProfileModal,
  // AssetManagerLetter
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundFossilFinanceInvestments.css'

// we could do pagination a few at a time, but we'll do click to show all
const FirstPage = 5
const AllPage = 1000000

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  // console.log('filtering holdings!!')
  // console.log(filterFn)
  return chain(holdings)
    .filter(filterFn)
    .sortBy((o)=>{ return fHoldingsMap[o.id].market_value * -1 })
    // .take(10)
    .value()
}


@CSSModules(Styles, {allowMultiple:true})
class SectorDetailsSwitches extends Component {
  static propTypes = {
    increment: PropTypes.func,
    sector: PropTypes.array,
    fund: PropTypes.object,
    shareClass: PropTypes.object,
    fHoldingsMap: PropTypes.object,
    sectorPages: PropTypes.object,
  }

  constructor(props){
    super(props)
  }

  render(){
    const {
      increment,
      sector,
      fund,
      shareClass,
      fHoldingsMap,
      sectorPages
    } = this.props

    //
    return (
      <div id={'sector-id-'+sector[0]}>
        <SectorDetailsSwitch
          type={sector[0]}
          label={sector[1]}
          sublabel={sector[2]}
          count={fund[sector[3]]}
          weight={fund[sector[4]]}
          asset={fund[sector[5]]}
          currency={shareClass.currency}
        >
        <HoldingListDisplay
          increment={increment}
          shareClass={shareClass}
          fHoldingsMap={fHoldingsMap}
          type={sector[0]}
          label={sector[1]}
          count={shareClass[sector[3]]}
          holdings={sector[6]}
          pages={sectorPages}
          score={fund[sector[7]]}
        />
        </SectorDetailsSwitch>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class SectorDetailsSwitch extends Component {
  static propTypes = {
    type: PropTypes.string,
    label: PropTypes.string,
    sublabel: PropTypes.string,
    count: PropTypes.string,
    weight: PropTypes.string,
    asset: PropTypes.string,
    currency: PropTypes.string,
  }

  constructor(props){
    super(props)
  }

  render(){
    const {
      type,
      label,
      sublabel,
      count,
      weight,
      asset,
      currency,
    } = this.props

    // filled in or greyed out?
    const currIcon = convert.int(count) ?
      require(`../../../static/images/icn-${type}.svg`) :
      require(`../../../static/images/icn-${type}-inactive.svg`)

    //
    return (
      <div styleName='detail-sector-wrapper'>
        <div styleName='detail-sector-title-stats-flex'>

          <div styleName='detail-sector-title-icon-wrap'>
            <div styleName='detail-sector-detail-icon-wrap'>
              <img styleName='detail-icon' src={currIcon} alt={label} />
            </div>
            <div styleName='detail-title'>
              <div><b>{label}</b></div>
              {
                sublabel ?
                  <div styleName='detail-sublabel'>
                    {sublabel}
                  </div> :
                  null
              }
            </div>
          </div>

          <div styleName='detail-stats-wrapper'>
            <div styleName='detail-stat'>
              <div styleName='detail-stat-value'>
                {format.number(count)}
              </div>
              <div styleName='detail-stat-label'>holdings</div>
            </div>
            <div styleName='detail-stat'>
              <div styleName='detail-stat-value'>
                {format.money(asset, true, currency, true)}
              </div>
              <div styleName='detail-stat-label'>invested</div>
            </div>
            <div styleName='detail-stat'>
              <div styleName='detail-stat-value'>
                {format.perc(weight)}
              </div>
              <div styleName='detail-stat-label'>of fund</div>
            </div>
          </div>

        </div>
        { this.props.children }
      </div>

    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class HoldingListDisplay extends Component {
  static propTypes = {
    increment: PropTypes.func,
    shareClass: PropTypes.object,
    fHoldingsMap: PropTypes.object,
    type: PropTypes.string,
    label: PropTypes.string,
    count: PropTypes.string,
    holdings: PropTypes.array,
    pages: PropTypes.object
  }

  constructor(props){
    super(props)
  }

  render(){
    const {
      increment,
      shareClass,
      fHoldingsMap,
      type,
      label,
      count,
      holdings,
      pages
    } = this.props

    const _count = convert.int(count)
    if (_count === 0) { return null }

    const page = pages[type] || 0
    const hasMoreButton = (page === 1 && _count > FirstPage) ?
      <div styleName='show-more-holdings-btn' onClick={increment(type)}>
        Show all<LinkIcon faclass='fa-angle-double-down' />
      </div> :
      null
    //
    return (
      <div>
        <HoldingList
          shareClass={shareClass}
          fHoldingsMap={fHoldingsMap}
          holdings={holdings}
          page={page}
          label={label}
        />
        <div styleName='show-more-holdings-btn-wrap'>
          {hasMoreButton}
        </div>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class HoldingList extends Component {
  static propTypes = {
    shareClass: PropTypes.object,
    fHoldingsMap: PropTypes.object,
    holdings: PropTypes.array,
    page: PropTypes.number,
    label: PropTypes.string,
  }

  constructor(props){
    super(props)
  }

  render(){
    const { shareClass, fHoldingsMap, holdings, page } = this.props

    if (!holdings || holdings.length === 0) {
      return <div>ERROR</div>
    }

    const takeCount = (page > 1) ? AllPage : FirstPage
    //
    return (
      <ul styleName='holding-list'>
        { /* HIDE ON MOBILE */ }
        <li styleName='holding holding-list-labels'>
          <div styleName='holding-name hidden-xs'>
            Holding
          </div>
          <div styleName='holding-values-labels hidden-xs'>
            <div styleName='holding-value'>
              Risk score
            </div>
            <div styleName='holding-value'>
              $ invested
            </div>
            <div styleName='holding-value'>
              % of fund
            </div>
          </div>
        </li>

        {
          chain(holdings)
            .take(takeCount)
            .map((h, idx) => {
              // useful formats
              const fPerc = format.perc(fHoldingsMap[h.id].long_weight)
              const fMoney = format.money(fHoldingsMap[h.id].market_value,
                                          true, shareClass.currency, true)
              const bankScore = format.number(h.fossil_bank_score,
                                              false, false, 2)
              const insureScore = format.number(h.fossil_insure_score,
                                                false, false, 2)
              //
              return (
                <li key={idx}>
                  <FinanceCompanyProfileModal
                    holding={h}
                    fundholding={fHoldingsMap[h.id]}
                  >
                    <div styleName='holding holding-hover'>
                      <div styleName='holding-name'>
                        {idx+1}.
                        &nbsp;
                        <b>{h.security_name}</b>
                      </div>
                      <div styleName='holding-values'>
                        <div styleName='holding-value'>
                          {
                            this.props.label === 'Banks' ?
                              <FinanceCompanyScore score={bankScore}/> :
                              <FinanceCompanyScore score={insureScore}/>
                          }
                        </div>
                        <div styleName='holding-value'>
                          {fMoney}
                        </div>
                        <div styleName='holding-value'>
                          {fPerc}
                        </div>
                      </div>
                      { /* MOBILE ONLY */ }
                      <div styleName='holding-values-labels hidden-sm hidden-md hidden-lg'>
                        <div styleName='holding-value'>
                          Risk score
                        </div>
                        <div styleName='holding-value'>
                          invested
                        </div>
                        <div styleName='holding-value'>
                          of fund
                        </div>
                      </div>
                    </div>
                  </FinanceCompanyProfileModal>
                </li>
              )
            })
            .value()
        }
      </ul>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class GradeBox extends Component {
  static propTypes = {
    grade: PropTypes.number,
    score: PropTypes.string,
    type: PropTypes.string
  }

  constructor(props){
    super(props)
  }

  render(){
    const { grade, score, type } = this.props
    const GR = format.score(grade)
    const gr = GR.toLowerCase()

    const tip = {
      'finance': format.scoreTipFossilFinance,
      'insurance': format.scoreTipFossilInsurance
    }[type](convert.float(score), GR)

    const methodologyAnchor = {
      'finance': 'methodology-fossil-fuel-finance',
      'insurance': 'methodology-fossil-fuel-insurance'
    }[type]

    //
    return (
      <div styleName={'grade-snapshot-'+gr}>
        <div styleName='grade-intro'>
          <div styleName='grade-intro-tip'>
            {tip}
          </div>
          <br/>
          <Link
            strong
            to={config.routes.banksInsurance + '#' + methodologyAnchor}
            title='Methodology'
          >
            <strong>Methodology<LinkIcon /></strong>
          </Link>
        </div>
        <div styleName='grade-wrapper'>
          <Grade
            grade={grade}
            large
          />
          <FinanceFundScore score={score} grade={grade}/>
        </div>
      </div>
    )
  }
}


@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions
)

@asyncConnect([{
  deferred: true, // need otherwise client navigate blocked until page loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(
      searchActions.shareClassDetails(
        params.fundId,
        params.investmentVehicleId
      )
    )
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundFossilFinanceInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.increment = this.increment.bind(this)
    this.state = {
      sectorPages: {
        ffb: 1,
        ffi: 1,
      }
    }
  }

  componentWillMount(){
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount(){
    analytics.event(
      analytics.eventLoadFund(
        this.props.params.fundId,
        this.props.params.investmentVehicleId
      )
    )
  }

  componentWillReceiveProps(nextProps){
  }

  // need this solution since asyncConnect and anchor links does not play nice
  // scrollTo = (id) => {
  //   return () => {
  //     const ele = document.getElementById(id)
  //     window.scrollTo(ele.offsetLeft, ele.offsetTop)
  //   }
  // }

  increment = (incState) => {
    return () => {
      const newState = { sectorPages: { 'ffb': 1, 'ffi': 1 } }
      newState.sectorPages[incState] = this.state.sectorPages[incState] + 1
      this.setState(newState)
    }
  }

  render(){
    // loading icons
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    } else if (
      this.props.result &&
      (
        !this.props.result.fund ||
        !this.props.result.shareClass
      )
    ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    }

    const { fund, shareClass } = this.props.result
    const { holdings, fundholdings } = fund
    const title = shareClass.fund_legal_name + ' | Banks and insurers'
    const url = config.domain + this.props.location.pathname

    // dividing up holdings by sector groups
    // could this be cached (e.g. in state) to improve performance?
    const fHoldingsMap = mapFundHoldings(fundholdings)
    const ffbHoldings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_fossil_bank) }
    )
    const ffiHoldings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_fossil_insure) }
    )

    // configs for "sector switch" totals and holdings lists
    const financeSectorConfig = [
      [
        'ffb',
        'Banks',
        'Banks providing lending to fossil fuels',
        'fossil_bank_count',
        'fossil_bank_weight',
        'fossil_bank_asset',
        ffbHoldings,
        'fossil_bank_score'
      ]
    ]

    const insuranceSectorConfig = [
      [
        'ffi',
        'Insurers',
        'Insurance companies insuring and investing in fossil fuels',
        'fossil_insure_count',
        'fossil_insure_weight',
        'fossil_insure_asset',
        ffiHoldings,
        'fossil_insure_score'
      ]
    ]

    const _ticker = shareClass.ticker || null
    let fundName = `${fund.fund_legal_name}`
    fundName = _ticker ? `${fundName} ${_ticker}` : fundName

    const description = `See if ${fundName} is invested in banks and insurers financing the climate crisis.`

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='fossil-fuel-banner-wrap'>
          <ContainerDivs>
            <h2 styleName='fossil-fuel-banner-hl'>
              <span styleName='fossil-fuel-banner-hl-lg'>Banks and insurers</span>
              <span styleName='fossil-fuel-banner-hl-sm'>are financing the climate crisis.</span>
            </h2>
          </ContainerDivs>
        </div>

        <br/>

        { /* FUND MENU COMPONENT */ }
        <FundMenu
          active='Banks & insurers'
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
          name={shareClass.fund_legal_name}
          ticker={shareClass.ticker}
        />

        { /* FUND NAME COMPONENT */ }
        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* temporary asset manager letter for Vanguard */ }
        { /* <AssetManagerLetter fundFamilyName={fund.fund_family_name}/> */ }

        <div styleName='main'>
          <ContainerDivs>

            { /* FOSSIL BANKS SECTION */ }
            <Row styleName='sidebar-content-wrap'>
              <Col xs={12} sm={12} md={12} lg={4} styleName='sidebar-wrap'>
                <h3 styleName='sidebar-headline'>
                  Fossil fuel finance
                </h3>
                <GradeBox
                  grade={fund.grade_fossil_bank}
                  score={fund.fossil_bank_score}
                  type='finance'
                />
              </Col>
              <Col xs={12} sm={12}md={12} lg={8} styleName='main-content-wrap'>
                <h3 styleName='main-content-lede'>
                  Commercial and investment banks' carbon-intensive funding is
                  fundamentally incompatible with reaching the 1.5-degree
                  aligned global goal necessary to prevent catastrophic
                  climate harm.
                </h3>

                { /* Bank sector details + holding list */
                  financeSectorConfig.map(sector=>{
                    return <SectorDetailsSwitches
                      key={sector[0]}
                      increment={this.increment}
                      sector={sector}
                      fund={fund}
                      shareClass={shareClass}
                      fHoldingsMap={fHoldingsMap}
                      sectorPages={this.state.sectorPages}
                    />
                  })
                }
                { /* DISCLAIMER TEXT FOR HOLDING LISTS */ }
                <div styleName='long-only-disclaimer'>
                  <div>
                    <LinkIcon nospace faclass='fa-info-circle' />
                  </div>
                  <div>
                    When calculating a portfolio's screen exposure, we only
                    consider long investments, ignoring any shorts or
                    liabilities.
                  </div>
                </div>
              </Col>
            </Row>

            { /* FOSSIL INSURANCE SECTION */ }
            <Row styleName='sidebar-content-wrap'>
              <Col xs={12} sm={12} md={12} lg={4} styleName='sidebar-wrap'>
                <h3 styleName='sidebar-headline'>
                  Fossil fuel insurance
                </h3>
                <GradeBox
                  grade={fund.grade_fossil_insure}
                  score={fund.fossil_insure_score}
                  type='insurance'
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} styleName='main-content-wrap'>
                <h3 styleName='main-content-lede'>
                  Primary insurers and reinsurers are continuing to underwrite
                  and invest in coal, oil, and gas, while experiencing
                  dramatic losses associated with catastrophic weather-related
                  events.
                </h3>

                { /* Insurance sector details + holding list */
                  insuranceSectorConfig.map(sector=>{
                    return <SectorDetailsSwitches
                      key={sector[0]}
                      increment={this.increment}
                      sector={sector}
                      fund={fund}
                      shareClass={shareClass}
                      fHoldingsMap={fHoldingsMap}
                      sectorPages={this.state.sectorPages}
                    />
                  })
                }
              </Col>
            </Row>

            <br/>
            <InlineSignup />

          </ContainerDivs>
        </div>

        { /* IYV REPORT CARD COMPONENT */ }
        <IyvScorecard fund={fund} shareClass={shareClass}/>
        
        { /* FUND TAKE ACTIONS COMPONENT */ }
        { /*
        <FundShareTakeAction shareClass={shareClass} url={url}/>
        */ }

      </div>
    )
  }
}
